module.exports = __webpack_public_path__ + "static/product-banner-hero-two-22f3d6705b832ef8ad3b388b081fa085.png";